// /components/reports/reportsEnums.js

export const REPORT_KINDS = {
  PERIODIC: 'Periodic',
  LESSON: 'Lesson',
  MOCK: 'Mock',
};

export const PERIODIC_REPORT_TYPES = {
  ACTIVITY: 'Activity',
  MOCK: 'Mock',
  TEST: 'Test',
};

export const REPORT_KIND_KEYS = Object.keys(REPORT_KINDS);
export const PERIODIC_REPORT_TYPE_KEYS = Object.keys(PERIODIC_REPORT_TYPES);